import React from 'react';
import { IconHorizontalPoints } from '../../../base/icons/svg';
import Button from '../../../base/ui/components/web/Button';
const ParticipantActionEllipsis = ({ accessibilityLabel, onClick }) => (React.createElement(Button, { accessibilityLabel: accessibilityLabel, icon: IconHorizontalPoints, onClick: onClick, size: 'small' }));
export default ParticipantActionEllipsis;
